import React, { useState, useEffect, useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { TextPage } from '../../../../components/TextPage/TextPage';
import { AuthorAvatar } from '../../../ArticleComponents/AuthorAvatar/AuthorAvatar';
import { ButtonBasic, usePagination, InputDynamicWidth, NoDataContent, ButtonClose } from "@lk-gtcom/ecomlab-components";
import { ButtonActionDrop } from '../../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import { ButtonsSort } from '../../../../components/Buttons/BurronsSort/ButtonsSort';
import { MoonLoader } from 'react-spinners';
import { useShallow } from 'zustand/react/shallow';
import dayjs from 'dayjs';
import './ContactCRM.scss';

// Заголовки таблицы
const header_list: string[] = [
    'Имя',
    'Фамилия',
    'Отчество',
    'Должность',
    "E-mail",
    "Телефон",
    'Способ общения',
    "Дата создания",
]

interface ContactCRMProps {
    modal?: boolean,
    setIsModal?: (isModal: boolean) => void
    addContact?: (contact_id: number | string) => void
}

type PaginatorParams = {
    page?: number;
    limit?: number;
    // Добавьте нужные поля
};

type PaginatorRefType = {
    params: PaginatorParams;
};

const btn_sort = [
    {
        label: 'По дате создания',
        value: 'created_at'
    },
    {
        label: 'A-Z',
        value: 'name'
    },
    {
        label: 'Email',
        value: 'name'
    },
    {
        label: 'Телефон',
        value: 'name'
    }
]

const ContactCRMСhoice = ({
    modal = false,
    setIsModal = () => { },
    addContact = () => { }
}: ContactCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const {
        isModalContact,
        setIsModalContact,
        currentContact,
        setCurrentContact
    } = useGeneralStore(
        useShallow((state) => ({
            currentContact: state.currentContact,
            isModalContact: state.isModalContact,
            setCurrentContact: state.setCurrentContact,
            setIsModalContact: state.setIsModalContact
        }))
    );

    const [contactList, setContactList] = useState([])
    const [load, setLoad] = useState(true)

    // Сортировка
    const [currentSort, setCurrentSort] = useState(null)
    const [sort, setSort] = useState(null)
    const [search, setSearch] = useState('')

    const btns = [
        {
            btn: 'Удалить',
            func: (e: React.MouseEvent) => {
                fetchDeleteContact(e)
            },
        },
    ];

    // Пагинация
    const paginatorRef = useRef<PaginatorRefType>()
    const paginatorCallback = useRef();
    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef?.current?.params
    );

    // Получение списка контактов
    const fetchGetContactList = (): void => {
        setLoad(true)
        let sort_param = `&order_direction=${sort == 'DESC' ? 'desc' : 'asc'}`
        let order_param = `&order_field=${currentSort?.value ? currentSort?.value : 'id'}`
        let search_param = `&search=${search}`

        let url = ` https://portals.ecomru.ru/api/crm/contacts/?page=${page}&limit=${limit}${order_param}${sort_param}${search_param}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const { data, total } = json
                if (Array.isArray(data)) {
                    setContactList(data);
                    setTotal(total)
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setLoad(false)
            })
    };

    // Удаление контакта
    const fetchDeleteContact = (id) => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('deleted contact')
                setTimeout(() => fetchGetContactList(), 1000)
            })
            .catch((err) => console.error(err));
    };



    useEffect(() => {
        if (!isModalContact) {
            setTimeout(() => fetchGetContactList(), 200)
        }
    }, [isModalContact, page, sort, search, limit]);

    return (
        <>
            <div className={modal ? 'blackout' : ''}
                style={{ zIndex: 12 }}
                onClick={(e) => {
                    let el = e.target as HTMLElement
                    if (el.classList.contains('blackout')) {
                        setIsModal(false)
                    }
                }}>

                <div className={`contact-CRM`}>

                    <div className={`contact-CRM__content-modal`}>
                        <div className={`contact-CRM__btn-group`}>
                            <ButtonsSort
                                btnSort={btn_sort}
                                sort={sort}
                                setSort={setSort}
                                currentSort={currentSort}
                                setCurrentSort={setCurrentSort}
                            //  disabled={load}
                            />

                            <InputDynamicWidth
                                position='left'
                                maxWidth='100%'
                                value={search}
                                onChange={e => setSearch(e)}
                                disabled={load}
                            />

                            {modal && <ButtonClose
                                onClick={() => setIsModal(false)}
                            />}
                        </div>

                        {load ?
                            <div className={`contact-CRM__load`}>
                                <MoonLoader
                                    color="#7b7b7b"
                                    speedMultiplier={0.5}
                                />
                            </div>
                            :
                            (contactList.length ?
                                <div className={`contact-CRM__table`}>
                                    <div className={`contact-CRM__table-headers`}>
                                        {header_list?.map((point) => {
                                            return <div
                                                className={`contact-CRM__table-headers-item`}
                                                key={point}
                                            >
                                                <TextPage
                                                    text={point}
                                                    style={{
                                                        fontWeight: 700
                                                    }}
                                                />
                                            </div>
                                        })}
                                    </div>

                                    {contactList?.map(({ id, email, phone, created_at, position, last_name, first_name, patronymic, communication }) => {
                                        const array_item = [first_name, last_name, patronymic, position, email, phone, communication, created_at]
                                        return <div
                                            className={`contact-CRM__table-row`}
                                            key={id}
                                            onClick={(e) => {
                                                if (modal) {
                                                    addContact(id)
                                                } else {
                                                    setCurrentContact(id)
                                                    setIsModalContact(true)
                                                }
                                            }}
                                        >
                                            {array_item.map((item, ind) => {
                                                return <div key={item + ind} className={`contact-CRM__table-row-item`}>
                                                    {(modal && ind === 0) && <>
                                                        <img className='contact-CRM__icon' src={'https://dl.ecomru.ru/svg-storage/done.svg'} />
                                                        <img className='contact-CRM__icon_active' src={'https://dl.ecomru.ru/svg-storage/done-active.svg'} />
                                                    </>}

                                                    {ind === 0 && <AuthorAvatar
                                                        size='s'
                                                        author={[item, '#3900b194']}
                                                    />}

                                                    <TextPage
                                                        text={(ind === 7 ? dayjs(created_at).format('DD.MM.YY HH:mm') : item) || 'Не назначено'}
                                                        style={{
                                                            color: item ? '' : '#888888'
                                                        }}
                                                    />
                                                </div>
                                            })}

                                            <ButtonActionDrop
                                                size='s'
                                                id={id}
                                                btns={btns}
                                            />
                                        </div>
                                    })}
                                </div>
                                :
                                <NoDataContent
                                    title="Нет контактов"
                                    description="Создайте новый контакт, чтобы пользоваться всеми инструментами сервиса"
                                />)
                        }
                        {Paginator}
                    </div>
                </div >
            </div>
        </>
    );
};

export { ContactCRMСhoice };